// extracted by mini-css-extract-plugin
export default {"toggle":"toggle___3HAc2","open":"open___3WFko","card":"card___SqDbo"};